import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject } from 'rxjs';


@Injectable({
  providedIn: 'root'
})
export class DataService {

  private messageSource = new BehaviorSubject('default message');
  currentMessage = this.messageSource.asObservable();

  constructor(private httpClient: HttpClient) { }


  changeMessage(message: string) {
    this.messageSource.next(message)
  }



  private REST_API_SERVER = "http://localhost/GCU.CarRental.API/api/Customer";

  

  public sendGetRequest(){

    return this.httpClient.get(this.REST_API_SERVER);
  }

  //public sendPostRequest(){
  //  return this.httpClient.post(this.REST_API_SERVER);
  //}



}
